<ng-template #addAnimalModal let-modal="close">
  <div class="modal-header" [ngSwitch]="modalType">
    <div class="modal-title" *ngSwitchCase="'add'">
      Animal nou
    </div>

    <div class="modal-title" *ngSwitchCase="'add-mother'">
      <span *ngIf="ascendenta">{{ascendenta}} -</span>
      Mamă nouă pentru vițel {{matricolChild}}
    </div>

    <div class="modal-title" *ngSwitchCase="'add-father'">
      <span *ngIf="ascendenta">{{ascendenta}} -</span>
      Tată nou pentru vițel {{matricolChild}}
    </div>

    <div class="modal-title" *ngSwitchCase="'edit'">
      Editează animal
    </div>

    <div class="modal-title" *ngSwitchCase="'view'">
      Vizualizează animal
    </div>

    <div class="modal-title" *ngSwitchDefault>
      Animal nou
    </div>


    <div class="btn-group custom-modal-btn">
      <button
        class="btn btn-sm btn-dark"
        (click)="modal('Cross click')"
        autofocus="false"
      >
        Închide
      </button>
      <button
        *ngIf="modalType != 'view'"
        type="submit"
        class="btn btn-sm btn-success"
        (click)="onSubmitted()"
        [ngClass]="{ 'disabled': disabledSubmit }"
      >
        <span *ngIf="modalType === 'add'; else editTxt">
          Salvează noul animal
        </span>
        <ng-template #editTxt>
          <span *ngIf="modalType === 'edit'; else parentTxt">
            Salvează
          </span>
        </ng-template>
        <ng-template #parentTxt>
          <span>
            Adaugă părinte
          </span>
        </ng-template>
      </button>
    </div>

  </div>

  <div class="d-flex overflow-auto">
    <div class="modal-sidebar d-none d-xl-block">
      <ul class="modal-menu">
        <li
          (click)="scrollToElement('#identificareAnimal')"
          [ngClass]="{ active: elemName.includes('identificareAnimal') }"
        >
          Identificare animal
        </li>

        <li
          *ngIf="animalForm.controls.sex.value === '1'"
          (click)="scrollToElement('#reproductie')"
          [ngClass]="{ active: elemName.includes('reproductie') }"
        >
          Reproducție
        </li>

        <li
          (click)="scrollToElement('#pedigree')"
          [ngClass]="{ active: elemName.includes('pedigree') }"
        >
          Pedigree
        </li>

        <li
          (click)="scrollToElement('#performanta')"
          [ngClass]="{ active: elemName.includes('performanta') }"
        >
          Performanță
        </li>

        <li
          (click)="scrollToElement('#registruGenealogic')"
          [ngClass]="{ active: elemName.includes('registruGenealogic') }"
        >
          Registru genealogic
        </li>

        <li
          (click)="scrollToElement('#pozeAnimal')"
          [ngClass]="{ active: elemName.includes('pozeAnimal') }"
        >
          Poze animal
        </li>
      </ul>
    </div>

    <div class="modal-body">
      <div class="container-fluid">
        <div class="">
          <form [formGroup]="animalForm">
            <!-- Identificare section -->
            <app-identificare-animal-form-block
              [animalForm]="animalForm"
              [disabledFields]="disabledFields"
              [submitted]="submitted"
              [modalType]="modalType"
              (selectedParent)="populateFields($event)"
              (closeUpdateModal)="closeUpdateModal()"
              (updateFields)="updateFieldsTrigger()"
            >
            </app-identificare-animal-form-block>

            <app-reproductie-form-block
              [animalForm]="animalForm"
              [disabledFields]="disabledFields"
              [submitted]="submitted"
            ></app-reproductie-form-block>

            <!-- Pedigree section -->
            <app-pedigree-form-block
              [animalForm]="animalForm"
              [disabledFields]="disabledFields"
              [updateFields]="updateFields"
            >
            </app-pedigree-form-block>

            <!-- Performance section -->
            <app-performanta-form-block
              [animalForm]="animalForm"
              [disabledFields]="disabledFields"
              [evaluareGenetica]="evaluareGenetica"
              [submitted]="submitted"
              (openBonitareModal)="bonitareModalChanged($event)"
            >
            </app-performanta-form-block>

            <!-- Registru genealogic section -->
            <app-registru-genealogic-form-block
              [animalForm]="animalForm"
              [disabledFields]="disabledFields"
              (disableSubmit)="disableSubmitButton($event)"
              (closeUpdateModal)="closeUpdateModal()"
            ></app-registru-genealogic-form-block>

            <app-poze-animal-form-block
              [animalForm]="animalForm"
              [disabledFields]="disabledFields"
            ></app-poze-animal-form-block>

          </form>
        </div>
      </div>
    </div>
  </div>

</ng-template>
